<template>
    <span :class="{ 'text-danger': `${parseFloat(difference)}` < 0, 'text-success': `${parseFloat(difference)}` > 0 }" class="font-weight-bold font-size-13">
        <feather
            v-if="parseFloat(difference) !== 0"
            :type="parseFloat(difference) > 0 ? 'arrow-up' : 'arrow-down'"
            size="12px"
            stroke-width="3"
        />
        {{ difference }}
    </span>
</template>



<script>
    export default {
        name: 'Difference',
        props: {
            difference: {
                type: [Number, String],
                default: '',
            },
        },
        data() {
            return {};
        },
    };
</script>
